import React, { useState } from "react";
// import signatureImg from "../../../../../Assets/assetsnew/signature-symbol.svg";
import SignProposal from "./SignProposal.jsx";
import TextStyles from "../../../../../Constants/TextStyles";
import Styled from "./SignatureStyles";
import SignatureImage from "../../../../../Assets/assetsnew/newSignature.svg"

const Signature = ({
  selectedData,
  data,
  businessInfoData,
  primaryContact,
}) => {
  const [showModal, setShowModal] = useState(false);

  const isDocSigned =
    selectedData &&
    selectedData.signature &&
    (selectedData.signature.text ||
      (selectedData.signature.image && selectedData.signature.image.image_url))
      ? true
      : false;

  return (
    <div className="mt-4">
      <Styled.ReviewBox className="mb-4">
        <div className="d-flex flex-wrap gap-3 justify-content-between align-items-center mb-3">
          <TextStyles.FontSize18px className="d-flex gap-2 gap-md-3 align-items-center">
            <img src={SignatureImage} alt="signatureImg" />
            <span className="fw-medium">Signature</span>
          </TextStyles.FontSize18px>
          <Styled.SignatureBox
            onClick={() => setShowModal(true)}
            className="ms-auto"
          >
            <div className="d-flex justify-content-center">
              {isDocSigned ? "Edit Signature" : "Sign Document"}
            </div>
          </Styled.SignatureBox>
        </div>

        {/* <div className="d-flex flex-wrap flex-sm-nowrap gap-2justify-content-sm-between align-items-center"> */}
        <div className="d-sm-flex justify-content-between">
          {/* <div className="d-flex flex-column justify-content-start w-100"> */}
          <div>
            <div
              style={{
                fontWeight: 400,
                fontSize: 36,
                height: 130,
              }}
              // className="d-flex justify-content-start"
              className="align-content-end"
            >
              {/* <div className="d-flex align-items-end h-100"> */}
                {selectedData &&
                  selectedData.client_signature &&
                  selectedData.client_signature.text && (
                    <div style={{ fontFamily: "licorice" }}>
                      {selectedData.client_signature.text}
                    </div>
                  )}

                {selectedData &&
                  selectedData.client_signature &&
                  selectedData.client_signature.image &&
                  selectedData.client_signature.image.image_name && (
                    <img
                      src={selectedData.client_signature.image.image_url}
                      alt="imageBtn"
                      style={{  maxHeight: 120, maxWidth: 200 }}
                    />
                  )}
              {/* </div> */}
            </div>

            {/* <TextStyles.FontSize16px className="d-flex justify-content-start"> */}
            <TextStyles.FontSize16px className="three-dots" style={{maxWidth:"400px"}}>
              {selectedData &&
                selectedData.client_id &&
                selectedData.client_id.company_name}
            </TextStyles.FontSize16px>

            {/* <TextStyles.GreyFont14px className="d-flex justify-content-start"> */}
            <TextStyles.GreyFont14px className="three-dots" style={{maxWidth:"400px"}}>
              {primaryContact && primaryContact.contact_name}
            </TextStyles.GreyFont14px>
          </div>

          {/* <div className="d-flex flex-column ms-auto justify-content-end w-100"> */}
          <div className="text-end">
            <div
              style={{
                fontWeight: 400,
                fontSize: 36,
                height: 130,
              }}
              // className="d-flex justify-content-end"
              className="align-content-end"
            >
              {/* <div className="d-flex align-items-end h-100"> */}
                {selectedData &&
                  selectedData.signature &&
                  selectedData.signature.text && (
                    <div style={{ fontFamily: "licorice" }}>
                      {selectedData.signature.text}
                    </div>
                  )}

                {selectedData &&
                  selectedData.signature &&
                  selectedData.signature.image &&
                  selectedData.signature.image.image_name && (
                    <img
                      src={selectedData.signature.image.image_url}
                      alt="imageBtn"
                      style={{ maxHeight: 120, maxWidth: 200 }}
                      className="mt-3 mt-sm-0"
                    />
                  )}
              {/* </div> */}
            </div>

            {/* <TextStyles.FontSize16px className="d-flex justify-content-end"> */}
            <TextStyles.FontSize16px className="mt-3 mt-md-0">
              {businessInfoData && businessInfoData.business_name
                ? businessInfoData.business_name
                : data && `${data.firstName} ${data.lastName}`}
            </TextStyles.FontSize16px>

            {/* <TextStyles.GreyFont14px className="d-flex justify-content-end"> */}
            <TextStyles.GreyFont14px>
              {businessInfoData &&
              businessInfoData.business_name !==
                `${data.firstName} ${data.lastName}`
                ? data && `${data.firstName} ${data.lastName}`
                : ""}
            </TextStyles.GreyFont14px>
          </div>
        </div>
      </Styled.ReviewBox>
      {showModal && (
        <SignProposal
          show={showModal}
          handleClose={() => setShowModal(false)}
          selectedData={selectedData}
        />
      )}
    </div>
  );
};

export default Signature;
